__turbopack_context__.v({
  "className": "roboto_slab_b595ab1d-module__rZH59W__className",
  "variable": "roboto_slab_b595ab1d-module__rZH59W__variable",
});
